"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _material = require("@mui/material");

var styles = {
  root: {
    display: 'block',
    backgroundColor: 'common.white',
    padding: 0,
    boxShadow: '0px 2px 5px rgba(51, 68, 124, 0.15)',
    borderRadius: '5px',
    border: 'none',
    textAlign: 'left',
    width: '100%'
  },
  rootClickable: {
    cursor: 'pointer'
  },
  header: {
    padding: 2
  },
  disabledText: {
    color: 'grey.main'
  },
  skeletonContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  skeletonAvatar: {
    height: 36,
    width: 36
  },
  skeletonTitle: {
    width: 150
  },
  skeletonSubtitle: {
    width: 275
  },
  skeletonFooter: {
    width: 90
  },
  headerTopContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  headerLeft: {
    display: 'flex',
    alighnItems: 'center'
  },
  headerRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  campaignInfoContainer: {
    marginLeft: 1
  },
  additionalCountriesContainer: {
    color: 'link.main',
    fontSize: '0.85rem'
  },
  title: {
    lineHeight: '1.5rem',
    color: 'primary.main',
    fontWeight: 700
  },
  subtitle: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: 'primary.main',
    display: 'flex',
    alignItems: 'center'
  },
  giftBudgetRange: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: 'green.fruitSalad'
  },
  countries: {
    ["& .".concat(_material.avatarClasses.root)]: {
      width: 16,
      height: 16,
      border: 'none',
      marginLeft: -0.5
    }
  },
  footer: {
    width: '100%',
    border: 'none',
    borderTop: "1px solid",
    borderColor: 'primary.superLight',
    color: 'link.main',
    paddingY: 1,
    paddingLeft: 7.5,
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    fontWeight: 700,
    cursor: 'pointer'
  },
  footerIcon: {
    marginLeft: 1
  },
  details: {
    paddingLeft: 7.5,
    paddingBottom: 2,
    paddingRight: 2,
    color: 'grey.chambray50',
    fontSize: '0.75rem',
    lineHeight: '1rem'
  },
  campaignDataContainer: {
    display: 'flex'
  },
  innerDataContainer: {
    flexBasis: '60%'
  },
  textEllipsis: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  defaultGiftContainer: {
    flexBasis: '40%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  defaultGiftHeader: {
    fontWeight: 700
  }
};
exports.styles = styles;